import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          transform="translate(0.500000, 7.000000)"
          fill="#64ffda"
          fillOpacity="1"
          strokeWidth="0.2"
          strokeLinejoin="round"
          d="M 54.6572,19L 42.1714,43.4879L 42.1714,57L 33.4857,57L 33.4857,43.6406L 21.5429,19L 31.3228,19L 37.4045,33.1736C 37.5063,33.4394 37.7947,34.4742 38.2697,36.2781L 38.3799,36.2781C 38.6118,35.0058 38.8917,34.0077 39.2197,33.2839L 45.5897,19L 54.6572,19 Z "
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
